import { Address, AgencyId, CompanyContactId, FEIN, SuretyAccountId } from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRef } from "react";
import { useRequest } from "../../../utils/request";
import { accountCompanyCheckQueryKey } from "../account.keys";

export type CompanyCheckResponse = {
	suretyAccountId: SuretyAccountId;
	companyContactId: CompanyContactId;
	companyName: string;
	companyAddress: Address;
	fein: FEIN | null;
	suretyAccountName: string | null;
	agencyId: AgencyId | null;
};

export const useAdminCheckCompanyByName = () => {
	const queryClient = useQueryClient();
	const { get } = useRequest();
	const namesAlreadyCheckedRef = useRef<string[]>([]);

	const mutation = useMutation({
		mutationKey: ["accountCreation", "checkCompany"],
		mutationFn: async (name: string) => {
			if (name === "") return [];
			if (namesAlreadyCheckedRef.current.includes(name)) return [];
			return await get<CompanyCheckResponse[]>(
				`/v2/admin/surety/accounts/companies/search?name=${encodeURIComponent(name)}`,
			);
		},
		onSuccess: (data: CompanyCheckResponse[], name) => {
			queryClient.setQueryData(accountCompanyCheckQueryKey(), data);
			if (!namesAlreadyCheckedRef.current.includes(name)) {
				namesAlreadyCheckedRef.current = [...namesAlreadyCheckedRef.current, name];
			}
		},
	});

	return {
		companyChecks: mutation.data,
		isLoading: mutation.isPending,
		error: mutation.error,
		checkCompanyByName: mutation.mutate,
	};
};
